import { render, staticRenderFns } from "./OrderIndex.vue?vue&type=template&id=4050597e&scoped=true"
import script from "./OrderIndex.vue?vue&type=script&lang=js"
export * from "./OrderIndex.vue?vue&type=script&lang=js"
import style0 from "./OrderIndex.vue?vue&type=style&index=0&id=4050597e&prod&lang=scss&scoped=true"
import style1 from "./OrderIndex.vue?vue&type=style&index=1&id=4050597e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4050597e",
  null
  
)

export default component.exports